"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectInitialPickupPoint = void 0;
var _react = require("react");
var _contexts = require("../../../contexts");
var _hooks = require("../../../hooks");
/**
 * Sets initial pickup point when there is no selected and pickup points are available
 */
const useSelectInitialPickupPoint = () => {
  const {
    pickupPointsMapProps: {
      setSelectedMapPickupPoint
    }
  } = (0, _contexts.useMap)();
  const {
    pickupPoints,
    selectedPickupPointId,
    setSelectedPickupPointId
  } = (0, _contexts.usePickupPoints)();
  const {
    mapMethods,
    mapConfiguration
  } = (0, _hooks.usePickupPointsSearchConfiguration)();
  const {
    zoomAfterSelection
  } = mapConfiguration ?? {};
  (0, _react.useEffect)(() => {
    if (selectedPickupPointId == null && pickupPoints.length > 0) {
      const [pickupPoint] = pickupPoints;
      if (pickupPoint?.latitude != null && pickupPoint.longitude != null) {
        setSelectedPickupPointId(pickupPoint.deliveryChannelId);
        setSelectedMapPickupPoint({
          deliveryChannelId: pickupPoint.deliveryChannelId,
          deliveryFee: pickupPoint.shippingFee,
          deliveryMethod: pickupPoint.deliveryMethod,
          isAllowed: true,
          isShippingJoker: pickupPoint.isShippingJoker,
          coordinates: {
            latitude: pickupPoint.latitude,
            longitude: pickupPoint.longitude
          },
          description: pickupPoint.description,
          estimatedDelivery: pickupPoint.estimatedDeliveryDate
        });
        mapMethods.current?.setLocationOrZoom({
          location: {
            latitude: pickupPoint.latitude,
            longitude: pickupPoint.longitude
          },
          zoom: zoomAfterSelection
        });
      }
    }
  }, [mapMethods, pickupPoints, selectedPickupPointId, setSelectedMapPickupPoint, setSelectedPickupPointId, zoomAfterSelection]);
};
exports.useSelectInitialPickupPoint = useSelectInitialPickupPoint;